import Button from "components/ui/Button/Button";
import { useHistory } from "react-router-dom";
import "pages/Dashboard/LatestGroupsPanel.scss";
import { ReactComponent as DecorationBottomLeft } from "pages/Dashboard/assets/decoration-bottom-left.svg";
import { ReactComponent as DecorationTopRight } from "pages/Dashboard/assets/decoration-top-right.svg";


function LatestGroupsPanel() {

  const history = useHistory();

  return (
    <div className={"latest-groups"}>
      <div className={"latest-groups__decoration latest-groups__decoration--left"}>
        <DecorationBottomLeft/>
      </div>
      <div className={"latest-groups__content"}>
        <div className={"latest-groups__text"}>
          <h3>Nieuw: Groepen</h3>
          <div>Van wandelgroep tot dichtclubje. Word lid van een groep of begin er zelf een!</div>
        </div>
        <div className={"latest-groups__cta"}>
          <Button variant={ 'secondary' } onClick={ () => history.push('/groepen') }>
            Bekijk alle groepen
          </Button>
        </div>
      </div>
      <div className={"latest-groups__decoration latest-groups__decoration--right"}>
        <DecorationTopRight/>
      </div>
    </div>
  );
}

export default LatestGroupsPanel;
